
(function () {
  var MACOMA_CATEGORY_CONTEXTS = [
    {
      path: '/collections/best-sellers-new-2024',
      ids: [],
      names: [
        'Apparel & Accessories',
        'Clothing',
        'Shoes',
        'Jewelry',
        'Handbags',
        'Dresses',
        'T-Shirts',
        'Blouses',
        'Tank Tops',
        'Jeans',
        'Sandals',
        'Sneakers'
      ]
    },
    {
      path: '/collections/new-arrivals-2024',
      ids: [],
      names: [
        'Apparel & Accessories',
        'Clothing',
        'Shoes',
        'Jewelry',
        'Handbags',
        'Dresses',
        'Blouses',
        'T-Shirts',
        'Tank Tops',
        'Jeans',
        'Sandals',
        'Sneakers'
      ]
    },
    {
      path: '/collections/shoes',
      ids: [],
      names: [
        'Shoes',
        '301 Sneakers',
        'Sneakers',
        '304 Sandals',
        'Sandals',
        'Flats',
        '302 Wedges & Heels',
        'Heels',
        '303 Mules & Boots',
        'Boots',
        'Athletic Shoes',
        'Slippers',
        'Shoe Accessories'
      ]
    },
    {
      path: '/collections/spring-2026-shoe-styles',
      ids: [],
      names: [
        'Shoes',
        '304 Sandals',
        'Sandals',
        '302 Wedges & Heels',
        'Heels',
        'Flats',
        '301 Sneakers',
        'Sneakers',
        '303 Mules & Boots',
        'Boots',
        'Slippers'
      ]
    },
    {
      path: '/collections/sneakers',
      ids: [],
      names: [
        '301 Sneakers',
        'Sneakers',
        'Athletic Shoes',
        'Shoes'
      ]
    },
    {
      path: '/collections/sandals',
      ids: [],
      names: [
        '304 Sandals',
        'Sandals',
        'Slippers',
        'Shoes'
      ]
    },
    {
      path: '/collections/flats-1',
      ids: [],
      names: [
        'Flats',
        'Shoes'
      ]
    },
    {
      path: '/collections/closed-toe-shoes',
      ids: [],
      names: [
        'Shoes',
        '301 Sneakers',
        'Sneakers',
        '303 Mules & Boots',
        'Boots',
        'Flats',
        'Athletic Shoes'
      ]
    },
    {
      path: '/collections/open-toe-shoes',
      ids: [],
      names: [
        'Shoes',
        '304 Sandals',
        'Sandals',
        '302 Wedges & Heels',
        'Heels',
        'Slippers'
      ]
    },
    {
      path: '/collections/the-first-step-collection',
      ids: [],
      names: [
        'Shoes',
        '304 Sandals',
        'Sandals',
        '302 Wedges & Heels',
        'Heels',
        'Flats',
        '301 Sneakers',
        'Sneakers',
        '303 Mules & Boots',
        'Boots'
      ]
    },
    {
      path: '/collections/corkys-footwear',
      ids: [],
      names: [
        'Shoes',
        '304 Sandals',
        'Sandals',
        '302 Wedges & Heels',
        'Heels',
        'Flats',
        '301 Sneakers',
        'Sneakers',
        '303 Mules & Boots',
        'Boots',
        'Slippers'
      ]
    },
    {
      path: '/collections/very-g-shoes',
      ids: [],
      names: [
        'Shoes',
        '301 Sneakers',
        'Sneakers',
        '304 Sandals',
        'Sandals',
        'Flats',
        '302 Wedges & Heels',
        'Heels',
        '303 Mules & Boots',
        'Boots'
      ]
    },
    {
      path: '/collections/spring-step-shoes-2',
      ids: [],
      names: [
        'Shoes',
        '304 Sandals',
        'Sandals',
        '302 Wedges & Heels',
        'Heels',
        'Flats',
        '301 Sneakers',
        'Sneakers',
        '303 Mules & Boots',
        'Boots'
      ]
    },
    {
      path: '/collections/wedges-and-heels',
      ids: [],
      names: [
        '302 Wedges & Heels',
        'Heels',
        'Sandals',
        'Shoes'
      ]
    },
    {
      path: '/collections/2-inch-heels',
      ids: [],
      names: [
        '302 Wedges & Heels',
        'Heels',
        'Shoes'
      ]
    },
    {
      path: '/collections/3-inch-heels',
      ids: [],
      names: [
        '302 Wedges & Heels',
        'Heels',
        'Shoes'
      ]
    },
    {
      path: '/collections/4-inch-heels-w-1-inch-platform',
      ids: [],
      names: [
        '302 Wedges & Heels',
        'Heels',
        'Shoes'
      ]
    },
    {
      path: '/collections/tops-2024',
      ids: [],
      names: [
        'Clothing Tops',
        'Shirts & Tops',
        'Blouses',
        'Shirts',
        'T-Shirts',
        'Tank Tops',
        '100 Short Sleeve',
        '410 Brami Tanks',
        'Bodysuits',
        'Hoodies',
        'Sweaters',
        'Sweatshirts'
      ]
    },
    {
      path: '/collections/tank-tops-2024',
      ids: [],
      names: [
        'Tank Tops',
        '410 Brami Tanks',
        'Activewear Tops',
        'Clothing Tops',
        'Shirts & Tops'
      ]
    },
    {
      path: '/collections/short-sleeve-tops-2024',
      ids: [],
      names: [
        '100 Short Sleeve',
        'T-Shirts',
        'Shirts',
        'Blouses',
        'Clothing Tops',
        'Shirts & Tops'
      ]
    },
    {
      path: '/collections/long-sleeve-tops-2024',
      ids: [],
      names: [
        'Clothing Tops',
        'Shirts & Tops',
        'Blouses',
        'Shirts',
        'Sweaters',
        'Sweatshirts',
        'Hoodies',
        'Cardigans'
      ]
    },
    {
      path: '/collections/sweaters-2024',
      ids: [],
      names: [
        '130 Sweaters',
        'Sweaters',
        'Sweatshirts',
        'Hoodies',
        'Cardigans'
      ]
    },
    {
      path: '/collections/graphic-tees',
      ids: [],
      names: [
        'T-Shirts',
        '100 Short Sleeve',
        'Shirts',
        'Clothing Tops',
        'Shirts & Tops'
      ]
    },
    {
      path: '/collections/sets',
      ids: [],
      names: [
        'Outfit Sets',
        'Suits',
        'Clothing',
        'Clothing Tops',
        'Pants',
        'Shorts',
        'Skirts'
      ]
    },
    {
      path: '/collections/bottoms-2024',
      ids: [],
      names: [
        'Pants',
        'Trousers',
        'Jeans',
        '170 Denim',
        'Shorts',
        '180 Shorts',
        'Skirts',
        '200 Skirts',
        'Skorts',
        'Joggers',
        'Cargo Pants',
        'Cargo Shorts',
        'Denim Shorts',
        'Short Trousers',
        'Sweatpants',
        'Loungewear Bottoms',
        '210 Other Bottoms'
      ]
    },
    {
      path: '/collections/denim-1',
      ids: [],
      names: [
        '170 Denim',
        'Denim',
        'Jeans',
        'Denim Shorts',
        'Trucker Jackets'
      ]
    },
    {
      path: '/collections/non-distressed-jeans-2024',
      ids: [],
      names: [
        'Jeans',
        '170 Denim',
        'Denim',
        'Trousers'
      ]
    },
    {
      path: '/collections/pants',
      ids: [],
      names: [
        'Pants',
        'Trousers',
        'Cargo Pants',
        'Joggers',
        'Sweatpants',
        '210 Other Bottoms'
      ]
    },
    {
      path: '/collections/shorts-1',
      ids: [],
      names: [
        '180 Shorts',
        'Shorts',
        'Denim Shorts',
        'Jogger Shorts',
        'Cargo Shorts',
        'Bermudas',
        'Short Trousers'
      ]
    },
    {
      path: '/collections/skirts-1',
      ids: [],
      names: [
        '200 Skirts',
        'Skirts',
        'Skorts'
      ]
    },
    {
      path: '/collections/rompers-jumpsuits',
      ids: [],
      names: [
        '260 Jumpsuits/Rompers/ Overalls',
        'One-Pieces',
        'Leotards & Unitards',
        'Clothing'
      ]
    },
    {
      path: '/collections/dresses-2024',
      ids: [],
      names: [
        '250 Dresses',
        'Dresses',
        '440 Brami Dress'
      ]
    },
    {
      path: '/collections/short-dresses-2024',
      ids: [],
      names: [
        '250 Dresses',
        'Dresses',
        '440 Brami Dress'
      ]
    },
    {
      path: '/collections/long-dresses-1',
      ids: [],
      names: [
        '250 Dresses',
        'Dresses',
        '440 Brami Dress'
      ]
    },
    {
      path: '/collections/outerwear-2024',
      ids: [],
      names: [
        'Outerwear',
        'Coats & Jackets',
        '240 Jackets/Blazers',
        'Jackets',
        'Bomber Jackets',
        'Puffer Jackets',
        'Trucker Jackets',
        'Sport Jackets',
        'Overcoats',
        'Wrap Coats',
        'Vests',
        'Cardigans'
      ]
    },
    {
      path: '/collections/cardigans',
      ids: [],
      names: [
        'Cardigans',
        'Sweaters',
        '130 Sweaters',
        'Outerwear'
      ]
    },
    {
      path: '/collections/jackets-blazers',
      ids: [],
      names: [
        '240 Jackets/Blazers',
        'Coats & Jackets',
        'Jackets',
        'Bomber Jackets',
        'Puffer Jackets',
        'Trucker Jackets',
        'Sport Jackets',
        'Outerwear'
      ]
    },
    {
      path: '/collections/vests',
      ids: [],
      names: [
        'Vests',
        'Outerwear',
        'Coats & Jackets'
      ]
    },
    {
      path: '/collections/curvy',
      ids: [],
      names: [
        'Clothing',
        'Dresses',
        'Blouses',
        'Clothing Tops',
        'Shirts & Tops',
        'T-Shirts',
        'Tank Tops',
        'Jeans',
        'Pants',
        'Shorts',
        'Skirts',
        'Outerwear'
      ]
    },
    {
      path: '/collections/accessories-2024',
      ids: [],
      names: [
        '310 Accessories/Jewelry',
        'Clothing Accessories',
        'Jewelry',
        'Handbags',
        'Handbags, Wallets & Cases',
        'Handbag & Wallet Accessories',
        'Wallets',
        'Belts',
        'Hats',
        'Baseball Caps',
        'Sunglasses',
        'Headbands',
        'Socks',
        'Keychains',
        'Tote Bags'
      ]
    },
    {
      path: '/collections/jewelry',
      ids: [],
      names: [
        '310 Accessories/Jewelry',
        'Jewelry',
        'Earrings',
        'Necklaces',
        'Bracelets',
        'Rings',
        'Anklets',
        'Charms & Pendants',
        'Body Jewelry',
        'Jewelry Sets'
      ]
    },
    {
      path: '/collections/tova-jewelry',
      ids: [],
      names: [
        '310 Accessories/Jewelry',
        'Jewelry',
        'Earrings',
        'Necklaces',
        'Bracelets',
        'Rings',
        'Anklets',
        'Charms & Pendants',
        'Body Jewelry',
        'Jewelry Sets'
      ]
    },
    {
      path: '/collections/final-sale-2024',
      ids: [],
      names: [
        'Apparel & Accessories',
        'Clothing',
        'Shoes',
        'Jewelry',
        'Handbags',
        'Dresses',
        'T-Shirts',
        'Jeans',
        'Sandals',
        'Sneakers',
        'Health & Beauty',
        'Uncategorized'
      ]
    },
    {
      path: '/collections/golden-days-ahead',
      ids: [],
      names: [
        'Dresses',
        'Tank Tops',
        'Shorts',
        'Sandals',
        '304 Sandals',
        'Sunglasses',
        'Jewelry',
        'Apparel & Accessories',
        'Clothing',
        'Shoes'
      ]
    },
    {
      path: '/collections/map-free-corkys',
      ids: [],
      names: [
        'Shoes',
        '304 Sandals',
        'Sandals',
        '302 Wedges & Heels',
        'Heels',
        'Flats',
        '301 Sneakers',
        'Sneakers',
        '303 Mules & Boots',
        'Boots',
        'Slippers'
      ]
    }
  ];

  var DEFAULT_CATEGORY_CONTEXT = {
    path: '__default__',
    ids: [],
    names: [
      'Apparel & Accessories',
      'Clothing',
      'Shoes',
      'Jewelry',
      'Handbags',
      'Dresses',
      'Blouses',
      'T-Shirts',
      'Tank Tops',
      'Jeans',
      'Sandals',
      'Sneakers'
    ]
  };

  function normalizePath(path) {
    path = String(path || '');

    path = path.split('?')[0];
    path = path.split('#')[0];
    path = path.replace(/^https?:\/\/[^/]+/i, '');
    path = path.replace(/\/+$/g, '');
    path = path.toLowerCase();

    return path || '/';
  }

  function endsWithText(value, suffix) {
    value = String(value || '');
    suffix = String(suffix || '');

    return value.slice(-suffix.length) === suffix;
  }

  function singularize(token) {
    if (endsWithText(token, 'ies')) {
      return token.slice(0, -3) + 'y';
    }

    if (endsWithText(token, 'es')) {
      return token.slice(0, -2);
    }

    if (endsWithText(token, 's')) {
      return token.slice(0, -1);
    }

    return token;
  }

  function isIgnoredToken(token) {
    var ignored = ['and', 'the', 'new', 'w', '1', '2', '3', '4'];

    return ignored.indexOf(token) >= 0;
  }

  function tokenize(value) {
    var rawTokens = String(value || '')
      .toLowerCase()
      .replace(/\b20\d{2}\b/g, ' ')
      .replace(/\bcollections?\b/g, ' ')
      .replace(/[^a-z0-9]+/g, ' ')
      .split(' ');

    var tokens = [];
    var i;

    for (i = 0; i < rawTokens.length; i += 1) {
      var token = singularize(rawTokens[i]);

      if (token && !isIgnoredToken(token)) {
        tokens.push(token);
      }
    }

    return tokens;
  }

  function uniqueValues(values) {
    var seen = {};
    var result = [];
    var i;

    values = values || [];

    for (i = 0; i < values.length; i += 1) {
      var value = String(values[i] || '').replace(/^\s+|\s+$/g, '');
      var key = value.toLowerCase();

      if (key && !seen[key]) {
        seen[key] = true;
        result.push(value);
      }
    }

    return result;
  }

  function tokensToMap(tokens) {
    var map = {};
    var i;

    for (i = 0; i < tokens.length; i += 1) {
      map[tokens[i]] = true;
    }

    return map;
  }

  function getCurrentPath() {
    try {
      return normalizePath(window.location.pathname);
    } catch (error) {
      return '/';
    }
  }

  function scoreContextByPath(currentPath, context) {
    var contextPath = normalizePath(context.path);
    var currentTokens;
    var currentTokenMap;
    var contextTokens;
    var score = 0;
    var i;

    if (currentPath === contextPath) {
      return 10000;
    }

    if (currentPath.indexOf(contextPath + '/') === 0) {
      return 9000;
    }

    currentTokens = tokenize(currentPath);
    currentTokenMap = tokensToMap(currentTokens);
    contextTokens = tokenize(context.path + ' ' + (context.names || []).join(' '));

    for (i = 0; i < contextTokens.length; i += 1) {
      if (currentTokenMap[contextTokens[i]]) {
        score += 1;
      }
    }

    return score;
  }

  function findBestContext(currentPath) {
    var bestContext = null;
    var bestScore = 0;
    var i;

    for (i = 0; i < MACOMA_CATEGORY_CONTEXTS.length; i += 1) {
      var context = MACOMA_CATEGORY_CONTEXTS[i];
      var score = scoreContextByPath(currentPath, context);

      if (score > bestScore) {
        bestScore = score;
        bestContext = context;
      }
    }

    return bestContext || DEFAULT_CATEGORY_CONTEXT;
  }

  function getActiveCategories(context) {
    var validIds = [];
    var validNames;
    var i;

    context = context || DEFAULT_CATEGORY_CONTEXT;

    var uniqueIds = uniqueValues(context.ids || []);

    for (i = 0; i < uniqueIds.length; i += 1) {
      var parsedId = Number(uniqueIds[i]);

      if (isFinite(parsedId) && parsedId > 0) {
        validIds.push(parsedId);
      }
    }

    if (validIds.length) {
      var idResult = [];

      for (i = 0; i < validIds.length; i += 1) {
        idResult.push({ id: validIds[i] });
      }

      return idResult;
    }

    validNames = uniqueValues(context.names || []);

    if (validNames.length) {
      var nameResult = [];

      for (i = 0; i < validNames.length; i += 1) {
        nameResult.push({ name: validNames[i] });
      }

      return nameResult;
    }

    var defaultResult = [];

    for (i = 0; i < DEFAULT_CATEGORY_CONTEXT.names.length; i += 1) {
      defaultResult.push({ name: DEFAULT_CATEGORY_CONTEXT.names[i] });
    }

    return defaultResult;
  }

 var currentPath = getCurrentPath();
  var activeContext = findBestContext(currentPath);

  window.coderIvyCategoryContexts = MACOMA_CATEGORY_CONTEXTS;
  window.coderIvyActiveCategoryContext = activeContext;
  window.coderIvyActiveCategories = getActiveCategories(activeContext);

  if (activeContext.path !== DEFAULT_CATEGORY_CONTEXT.path) {
    window.coderIvyPage = 'category';
    // localStorage.setItem('coderivy-products', JSON.stringify([]));
  }
})();